/** @jsxImportSource @emotion/react */
import { Global } from '@emotion/react';
import { Reset } from './style/Reset';
import { useLocation } from 'react-router-dom';
import Header from './components/header/Header';
import Footer from './components/footer/Footer';
import { useEffect, useState } from 'react';
import { useLogging } from './hooks/useLogging';
import { AppRoutes } from './routes/AppRoutes';
import { documentContainer, mainContainer } from './styles/AppStyles';
import { AuthProvider } from './context/AuthContext';
import { AnimatePresence } from 'framer-motion';

const ROOT_PATH = '/';

function App() {
    const location = useLocation();
    const [currentPathName, setCurrentPathName] = useState(location.pathname);
    const [isRoot, setIsRoot] = useState(location.pathname === ROOT_PATH);

    // 로깅 훅 사용
    useLogging(location.pathname);

    useEffect(() => {
        setCurrentPathName(location.pathname);
        setIsRoot(location.pathname === ROOT_PATH);
    }, [location.pathname]);

    return (
        <AuthProvider>
            <div css={documentContainer(isRoot)}>
                <Global styles={Reset} />
                <Header currentPathName={currentPathName} isRoot={isRoot} />
                <main css={mainContainer}>
                    <AnimatePresence mode="wait">
                        <AppRoutes key={location.pathname} />
                    </AnimatePresence>
                </main>
                <Footer currentPathName={currentPathName} isRoot={isRoot} />
            </div>
        </AuthProvider>
    );
}

export default App;
